import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { images } from '../../data/images';
import { site } from '../../data/site';
import { buttonStyles, container, focusRing } from '../../utils/styles';
export function HomeHero() {
  const {
    t
  } = useLanguage();
  return <section className="relative bg-brand-deeper" aria-labelledby="hero-heading" data-id="element-28" data-mp="2wuddsmcih388">
      <div className="relative h-64 sm:h-96 md:absolute md:inset-0 md:h-auto" data-id="element-29" data-mp="2wwhgx22l5y7g">
        <img src={images.hero.src} alt={t(images.hero.alt)} className="h-full w-full object-cover object-[center_30%]" data-id="element-30" data-mp="31seu4zijyog0" />
        <div className="absolute inset-0 hidden bg-[#12283D]/60 md:block" aria-hidden="true" data-id="element-31" data-mp="2n2hc71b7uuz9" />
        <p className="absolute right-4 top-4 inline-flex items-center gap-2 rounded-full bg-gold px-4 py-2 text-sm font-semibold text-brand-deeper shadow-md sm:right-6 sm:top-6 lg:right-8" data-id="element-32" data-mp="2s125shvyqgeq">
          <span className="h-2 w-2 rounded-full bg-sage-dark" aria-hidden="true" data-id="element-33" data-mp="3klslkun24cqv" />
          {t({
          en: 'Now Accepting New Clients',
          es: 'Aceptando Nuevos Clientes'
        })}
        </p>
      </div>
      <div className={`${container} relative py-12 md:py-28 lg:py-36`} data-id="element-34" data-mp="jxz2hr3ppw41">
        <div className="max-w-2xl text-white" data-id="element-35" data-mp="xocatukinctw">
          <h1 id="hero-heading" className="text-4xl font-bold leading-[1.12] sm:text-5xl lg:text-[3.4rem]" data-id="element-36" data-mp="xpdjxthz1p8z">
            {t({
            en: 'Caring for Your Loved Ones Like Our Own Family',
            es: 'Cuidando a Tus Seres Queridos Como Nuestra Propia Familia'
          })}
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/90 sm:text-xl sm:leading-relaxed" data-id="element-37" data-mp="1gmesfoaqi7ho">
            {t({
            en: 'A.M. Home Care, Inc. provides trusted, personalized in-home care — helping your loved ones live safely, comfortably, and with dignity in the place they love. Serving families across Northern Virginia with 24/7 professional caregiving.',
            es: 'A.M. Home Care, Inc. proporciona cuidado personalizado de confianza en el hogar — ayudando a tus seres queridos a vivir de manera segura, cómoda y con dignidad en el lugar que aman. Sirviendo familias en todo el norte de Virginia con cuidado profesional 24/7.'
          })}
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-38" data-mp="1rc2rqrzlg9n5">
            <Link to="/contact" className={`${buttonStyles.primary} min-h-[56px] bg-brand-light px-8 text-lg hover:bg-brand`} data-id="element-39" data-mp="1wae2r61mkq6y">
              <CalendarIcon className="h-5 w-5" aria-hidden="true" data-id="element-40" data-mp="208k4u0riqhlj" />
              {t({
              en: 'Schedule a Consultation',
              es: 'Agendar Consulta'
            })}
            </Link>
            <Link to="/services" className={`${buttonStyles.outlineLight} min-h-[56px] px-8 text-lg`} data-id="element-41" data-mp="2a1it1hj3s64m">
              {t({
              en: 'Learn About Our Services',
              es: 'Conocer Nuestros Servicios'
            })}
            </Link>
          </div>
          <p className="mt-7 text-white/85" data-id="element-42" data-mp="2jwaskqw8x321">
            {t({
            en: 'Or call us now, 24/7:',
            es: 'O llámanos ahora, 24/7:'
          })}{' '}
            <a href={site.tel} className={`inline-flex items-center gap-1.5 rounded font-display text-xl font-bold text-white underline-offset-4 hover:underline ${focusRing}`} data-id="element-43" data-mp="ccdqbfkm1fuf">
              <PhoneIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-44" data-mp="8delduyvpj2z" />
              {site.phoneDisplay}
            </a>
          </p>
        </div>
      </div>
    </section>;
}